import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  InputBase,
  Select,
  MenuItem,
  Link,
  Checkbox,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { OpenInNew } from "@mui/icons-material";
import Organization from "../settings/Organization";
import TwilioIntegration from "../settings/TwilioIntegration";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Account from "../settings/Account";
import Users from "../settings/Users";
import Billing from "../settings/Billing";
import { Building, CreditCard, Unplug, UsersIcon } from "lucide-react";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userRole, setUserRole] = useState(JSON.parse(localStorage.getItem("organization")).users.L.find((u)=> u.M.userId.S === JSON.parse(localStorage.getItem("user")).userId.S).M.type.S)

  return (
    <div className="pt-7 px-4 min-w-0 max-w-full">
      <div className="lg:text-[22px] text-[20px] font-bold mb-4 lg:mt-0 mt-8 ">
        Settings
      </div>

     {userRole == "owner" || userRole == "admin" ? 
     (
      <div className="rounded-[13px] xl:min-h-[85vh] h-fit w-full my-5 py-5 relative min-w-0 overflow-hidden">
        <div className="grid grid-cols-1 xl:grid-cols-9 gap-4 h-fit min-w-0">
          <div className="xl:col-span-2 py-4 h-fit col-span-1 w-full flex flex-col xl:space-y-3 px-2 border border-[#E6E7EB] bg-white rounded-[10px] mb-4 xl:mb-0 shrink-0">
            <div
              onClick={() => {
                navigate("/dashboard/settings/organization");
              }}
              className={
                location.pathname === "/dashboard/settings/organization" ||
                location.pathname === "/dashboard/settings"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] xl:rounded-[5px] py-2 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-[#111827]  font-semibold xl:rounded-[10px] py-1 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              <Building className="inline  text-[#111827] mr-2 mb-1 h-4 w-4 " />
              Organization
            </div>

            <div
              onClick={() => {
                navigate("/dashboard/settings/twilio-integration");
              }}
              className={
                location.pathname === "/dashboard/settings/twilio-integration"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] xl:rounded-[5px] py-2 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-[#111827]  font-semibold xl:rounded-[10px] py-1 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              <Unplug className="inline  text-[#111827] mr-2 mb-1 h-4 w-4 " />
              Twilio Integration
            </div>

            <div
              onClick={() => {
                navigate("/dashboard/settings/users");
              }}
              className={
                location.pathname === "/dashboard/settings/users"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] xl:rounded-[5px] py-2 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-[#111827]  font-semibold xl:rounded-[10px] py-1 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              <UsersIcon className="inline  text-[#111827] mr-2 mb-1 h-4 w-4 " />
              Users
            </div>
            <div
              onClick={() => {
                navigate("/dashboard/settings/billing");
              }}
              className={
                location.pathname === "/dashboard/settings/billing"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] xl:rounded-[5px] py-2 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-[#111827]  font-semibold xl:rounded-[10px] py-1 px-2 xl:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              <CreditCard className="inline  text-[#111827] mr-2 mb-1 h-4 w-4 " />
              Billing
            </div>
          </div>
          <div
            className={
              location.pathname === "/dashboard/settings/billing"
                ? "xl:col-span-7 col-span-1 min-w-0 h-full w-full xl:px-6 px-4 overflow-auto"
                : "xl:col-span-7 col-span-1 min-w-0 h-full w-full xl:px-6 px-4 overflow-auto bg-white border border-[#E6E7EB] rounded-[5px]"
            }
          >
            <Routes>
              <Route path="/" element={<Organization />} />
              <Route path="/organization" element={<Organization />} />
              <Route path="/twilio-integration" element={<TwilioIntegration />} />
              <Route path="/account" element={<Account />} />
              <Route path="/users" element={<Users />} />
              <Route path="/billing" element={<Billing />} />
            </Routes>
          </div>
        </div>
      </div>
     ): (
      <div className="text-[14px] text-center">
  You do not have access to the settings page. Contact your admin for{" "}
  <a
    href="mailto:hello@twilanswer.com"
    className="text-[#6C4FFF] underline cursor-pointer"
  >
    support
  </a>.
</div>
     )
     }
    </div>
  );
};

export default Settings;
